import React, { useContext } from 'react';

import {
  DashboardPortalContext,
  setErrorMessage,
} from 'presentations/reducers/DashboardPortal';
import Snackbar from 'presentations/views/components/atoms/Snackbar';

export default function Component() {
  const { state, dispatch } = useContext(DashboardPortalContext);
  if (
    typeof state.snackbarMessage !== 'string' &&
    typeof state.snackbarMessage !== 'object'
  ) {
    return null;
  }
  return (
    <Snackbar
      onClose={() => dispatch(setErrorMessage(undefined))}
      isOpen={true}
      severity={state.snackbarSeverity}
      message={state.snackbarMessage}
    />
  );
}
